import { HIDE_PARTNER_TUTORIALS_KEY } from '@/constants/videoTutorials';
import { log } from '@/utils/functions/logger/logger';

const writePartnerTutorialsPreference = (hidden: boolean): void => {
  try {
    if (hidden) globalThis.localStorage.setItem(HIDE_PARTNER_TUTORIALS_KEY, 'true');
    else globalThis.localStorage.removeItem(HIDE_PARTNER_TUTORIALS_KEY);
  } catch (error) {
    log.warn('[partnerTutorialsPreference] Écriture impossible', error);
  }
};

export default writePartnerTutorialsPreference;
